import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorHouseSlider from "./house-slider/BuilderEstimatorHouseSlider.vue";
  import BuilderEstimatorHouseFeaturesMobile from "./house-features/BuilderEstimatorHouseFeaturesMobile.vue";
  import BuilderEstimatorHouseCarousel from "./house-carousel/BuilderEstimatorHouseCarousel.vue";
  import BuilderEstimatorHouseFeaturesDesktop from "./house-features/BuilderEstimatorHouseFeaturesDesktop.vue";

  import { BuilderFeatures } from "@/enums/BuilderFeatures";
  import { BuilderSliderSteps } from "@/enums/BuilderSliderSteps";

  import { formatPrice as formatMeters } from "@/helpers/transformation/price";

  import type { BuilderInterfaceWithHouseDesigns } from "@/types/BuilderInterface";
  import type { HouseDesignInterface } from "@/types/HouseDesignInterface";

  import { useBuilderEstimatorSelectionHouse } from "@/hooks/estimator-tool/useBuilderEstimatorSelectionHouse";
  import { onMounted, watch } from "vue";

  interface Props {
    selectedHouseDesign: HouseDesignInterface;
    selectedBuilder?: BuilderInterfaceWithHouseDesigns;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSelectionHouse',
  props: {
    selectedHouseDesign: {},
    selectedBuilder: {}
  },
  emits: ["update:selectHouseDesign", "back"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const onSelectBack = () => {
    emit("back");
  };

  const {
    currentFeature,
    currentSliderStep,
    isImageFloorplanModalOpen,
    showFloorplan,
    sliderImages,
    zoom,
    isDesktop,
    house,
    selectedBuilder,
    showBrowseInteriorsText,
    showColorsControls,
    showExitInteriorsButton,
    getColorsSelection,
    closeImageModal,
    exitInteriors,
    isImageAvailable,
    jumpToStep,
    onSelectColor,
    onSelectHouseImage: selectHouseImage,
    setCurrentFeature,
    updateZoom,
    initializeHouseDesign,
  } = useBuilderEstimatorSelectionHouse(props);

  const onSelectHouseImage = (houseId: string) => {
    emit("update:selectHouseDesign", selectHouseImage(houseId));
  };

  onMounted(() => {
    initializeHouseDesign();
  });

const __returned__ = { props, emit, onSelectBack, currentFeature, currentSliderStep, isImageFloorplanModalOpen, showFloorplan, sliderImages, zoom, isDesktop, house, selectedBuilder, showBrowseInteriorsText, showColorsControls, showExitInteriorsButton, getColorsSelection, closeImageModal, exitInteriors, isImageAvailable, jumpToStep, onSelectColor, selectHouseImage, setCurrentFeature, updateZoom, initializeHouseDesign, onSelectHouseImage, BuilderEstimatorHouseSlider, BuilderEstimatorHouseFeaturesMobile, BuilderEstimatorHouseCarousel, BuilderEstimatorHouseFeaturesDesktop, get BuilderFeatures() { return BuilderFeatures }, get BuilderSliderSteps() { return BuilderSliderSteps }, get formatMeters() { return formatMeters }, get useBuilderEstimatorSelectionHouse() { return useBuilderEstimatorSelectionHouse }, onMounted, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})